import type { IconName } from '@/assets/icons/icons';

import { datadogOffer } from './datadog';
import { metabaseOffer } from './metabase';
import { snowflakeOffer } from './snowflake';
import { zohoCrmOffer } from './zoho';

import type { CachedMCPServer } from '@littlebird/mcp';

/**
 * A "guided" custom MCP presents as a first-class tile in the integrations grid
 * but connects through a bespoke flow (e.g. a region picker that resolves a
 * per-DC URL) rather than a single shared catalog entry. Adding a new one is
 * data-only: append an offer here, no branching in the grid hook or modal.
 */
export interface GuidedCustomMcpOffer {
  id: string;
  name: string;
  description: string;
  icon: IconName;
  categories: string[];
  searchText: string;
  /** True once a matching server is connected, so the tile can be hidden. */
  isConnected: (servers: readonly CachedMCPServer[]) => boolean;
  /** Kicks off the guided connect flow; resolves after starting, not after connecting. */
  connect: () => void | Promise<void>;
}

export const GUIDED_CUSTOM_MCP_OFFERS: readonly GuidedCustomMcpOffer[] = [
  datadogOffer,
  metabaseOffer,
  snowflakeOffer,
  zohoCrmOffer,
];
